import React, { useState, useEffect } from "react";

import "./RecentPrompts.css";
import Badge from "react-bootstrap/Badge";
import Stack from "react-bootstrap/Stack";
import Button from "react-bootstrap/Button";
import axios from "axios";

export const RecentPrompts = (props) => {
  const [recentPrompts, setRecentPrompts] = useState([]);

  useEffect(() => {
    if (props.partnerMetadata) {
      axios
        .post(
          process.env.REACT_APP_API_DOMAIN + "/getTrendingMessages",
          {
            partnerId: props.partnerMetadata.partner_id,
          },
          {
            headers: {
              authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          setRecentPrompts(response.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [props.partnerMetadata]);

  const [recent_prompts_mx, setRecent_prompts_mx] = useState([
    // "Create a table that tracks cumulative lease repayment rates by loan origination cohort since January 2024 for Car loans. Each column corresponds to a specific loan origination month, and each row represents the number of months elapsed since origination. Each cell should contain the running repayment rate where running total of lease payments are divided by loan amount for each loan in the cohort group.",
    "Need a report for Mexico showing the a breakdown of all 2024 leases with car model, issued date, loan amount, monthly installment, interest rate",
    "For active loans that are of loan type Cash originated in the last 3 months, show me the loans with all fields and an extra computed one: 'remaining principal as of' which is the principal remaining",
    "Show me a report with the following details on payments: Amount, Timestamp, Client Uber ID filtered by loan notes body containing UberRental",
    "Can you help me pull the expected future installments by month for loans that are associated with the investor Untapped Inc.",

    "Create a table that tracks cumulative lease repayment rates by loan origination cohort since January 2024. Each column corresponds to a specific loan origination month, and each row represents the number of months elapsed since origination. Each cell should contain the running repayment rate where total of lease payments are divided by loan principal for each loan in the cohort group.",
  ]);

  const [recent_prompts_ugx, setRecent_prompts_ugx] = useState([
    "Create a table that tracks cumulative principal repayment rates by loan origination cohort since January 2024. Each column corresponds to a specific loan origination month, and each row represents the number of months elapsed since origination. Each cell should contain the running repayment rate where total of principal payments are divided by loan principal for each loan in the cohort group.",
    "Create a table that tracks write-off rate by loan origination cohort since January 2024. each column represents the origination month and each row represents the number of months elapsed since origination. Each cell should contain the running write-off ratio where the total principal written off is divided by the loan principal for each loan in the cohort group. Use write off date to determine when to a loan became written off.",
    "Show me recoveries received after write offs over time: how much of the written-off loan amounts are being recovered over time",
    "Can you help me pull the expected future installments by month for loans that are associated with the investor Untapped Inc.",
    "Show me loan volume over time by client's credit grade for Uganda Soft loans",
    "Show me the list of failed assignments for the month of Nov for Mukono branch",
    "Show me active loan volume in Gulu branch, broken down by assigned officer over month originated",
  ]);

  function onSetPrompt(id) {
    props.setRecentPrompt(id);
  }

  return (
    <div className="recentPromptsContainer">
      {props.partnerMetadata &&
      props.partnerMetadata.partner_name == "Asaak_Mexico" ? (
        <div>
          {" "}
          <Stack direction="vertical" gap={10}>
            <div className="recentPromptsList">
              <div className="recentPromptsHeader"> Trending Prompts</div>
              {recent_prompts_mx.map((prompt, i) => {
                return (
                  <Button
                    onClick={() => onSetPrompt(prompt)}
                    variant="outline-primary"
                    className="promptButton"
                  >
                    <div className="recentPromptText">{prompt}</div>
                  </Button>
                );
              })}
            </div>
          </Stack>
        </div>
      ) : props.partnerMetadata &&
        props.partnerMetadata.partner_name == "Asaak_Uganda" ? (
        <div>
          {" "}
          <Stack direction="vertical" gap={10}>
            <div className="recentPromptsList">
              <div className="recentPromptsHeader"> Trending Prompts</div>
              {recent_prompts_ugx.map((prompt, i) => {
                return (
                  <Button
                    onClick={() => onSetPrompt(prompt)}
                    variant="outline-primary"
                    className="promptButton"
                  >
                    <div className="recentPromptText">{prompt}</div>
                  </Button>
                );
              })}
            </div>
          </Stack>
        </div>
      ) : (
        <div>
          {" "}
          <Stack direction="vertical" gap={10}>
            <div className="recentPromptsList">
              <div className="recentPromptsHeader"> Trending Prompts</div>
              {recentPrompts.map((prompt, i) => {
                return (
                  <Button
                    onClick={() => onSetPrompt(prompt.outgoing_message)}
                    variant="outline-primary"
                    className="promptButton"
                  >
                    <div className="recentPromptText">
                      {prompt.outgoing_message}
                    </div>
                  </Button>
                );
              })}
            </div>
          </Stack>
        </div>
      )}
    </div>
  );
};

export default RecentPrompts;
